module.exports = __webpack_public_path__ + "img/valonia_logo1_rgb-e1569320033805.07e20f77.png";